import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import { useOutsideAndEscapeClose } from "../../../../../../../hooks";

import { DifferencesTable } from "./components/DifferencesTable/DifferencesTable";

import {
  DropDownButton,
  GridContainer,
  GridItemOne,
  GridItemTwo,
  Text,
  Wrapper,
} from "./Differences.styled";

export const Differences = () => {
  const [showDifferences, setShowDifferences] = useState(false);

  const { t } = useTranslation();
  const wrapperRef = useRef(null);

  const handleShowDifferences = e => {
    if (wrapperRef.current) {
      wrapperRef.current.scrollIntoView({ behavior: "smooth" });
    }

    setShowDifferences(prevState => !prevState);
  };

  useOutsideAndEscapeClose(wrapperRef, () => setShowDifferences(false));

  return (
    <Wrapper>
      <GridContainer container spacing={{ md: 3 }}>
        <GridItemOne>
          <Text>{t("global.heroSub")}</Text>
        </GridItemOne>

        <GridItemTwo ref={wrapperRef}>
          <DropDownButton onClick={handleShowDifferences}>
            {t("global.heroSubBtn")}
          </DropDownButton>

          {showDifferences && <DifferencesTable />}
        </GridItemTwo>
      </GridContainer>
    </Wrapper>
  );
};
